import {DispersionPage} from './DispersionPage';
export default DispersionPage;